<template src="./assetsadd.html"></template>
<script>
  import VueGallery from "vue-gallery";
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";
  import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
  var moment = require("moment");

  export default {
    components: {
      VueGallery,
      Multiselect,
    },
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
      showstring: function (data) {
        if (data == "" || data == null) {
          return "";
        } else {
          return data.replaceAll("_", " ");
        }
      },
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },

        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        DriverList: [],
        CategoryList: [],
        SubCategoryList: [],
        GroupList: [],
        LocationList: [],
        OwnershipList: [],
        ShowLoader: false,
        Saving: false,
        AdditionalFilesSaving: false,
        submitted: false,
        FileLoader: false,
        ShowBranches: false,
        Branches:{},
        AdditionalImages:[],
        AssetCheckSettings:["Confirm Safe Working Order"] ,
        NewAssets: {
          id: 0,
          branch_id:0,
          name: "",
          type: 0,
          responsibility: 0,
          description: "",
          serial_number: "",
          make: "",
          model: "",
          year: "",
          training_type: "",
          visibility: 1,
          photo: "",
          additional_photos: "",
          category: 0,
          sub_category: 0,
          group: 0,
          ownership: 0,
          location: 0,
          assignments: [],
          requires_servicing: "",
          service_interval_hours: "",
          service_interval_miles: "",
          service_interval_months: "",
          last_service_hours: "",
          last_service_miles: "",
          last_service_date: "",
          current_hours: "",
          current_miles: "",
          next_service_hours: "",
          next_service_miles: "",
          next_service_date: "",
          next_service_hours_before: "",
          next_service_miles_before: "",
          next_service_date_before: "",
          service_measurement: "",
          asset_check_settings:[],
          tracker_status: "No_Tracker",
          tracker_company: null,
          inseego_node_id: "",
          contract_start_date: "",
          contract_end_date: "",
        },
        
        select_branch:true,
        FleetSubscriptionModules:[],
        ShowKM:false,
      };
    },
    validations: {
      NewAssets: {
        name: { required },
        type: { required },
        responsibility: { required },
        //description: { required },
        serial_number: { required },
        make: { required },
        model: { required },
        year: { required },
        service_measurement: { required },
        //training_type: { required },

        //requires_servicing: { required },
      },
    },
    mounted() {

      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      if (CompanyData && CompanyData.mileage_unit == 2) {
        this.ShowKM = true;
      }

      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
        );
        this.FleetSubscription = JSON.parse(
          localStorage.getItem("FleetSubscription")
        );
        var FleetSubscriptionModules = JSON.parse(
          this.FleetSubscription.fleet_modules
        );
        this.FleetSubscriptionModules = FleetSubscriptionModules;
        if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable || !AccountPermissions.Assets.add) ){
          this.$router.push('/');
        }

      //check account permission
      if (this.FleetSubscriptionModules && 
      this.FleetSubscriptionModules.Branches) {
        this.ShowBranches = true;
      }

      document.title = pbx_SiteTitle + " - Assets Add";
      this.initAssignments();

      this.GetDriverList();
      this.GetCategoryList();
      this.GetGroupList();
      this.GetLocationList();
      this.GetOwnershipList();
      this.GetBranches();
    },

    methods: {
      checkMeasurement(){
        var service_measurement = this.NewAssets.service_measurement;
        this.AssetCheckSettings.splice(this.AssetCheckSettings.indexOf('Record Current Miles'));
        this.AssetCheckSettings.splice(this.AssetCheckSettings.indexOf('Record Current Hours'));
        this.AssetCheckSettings.push('Confirm Safe Working Order');
        if(service_measurement == "Miles"){
          this.AssetCheckSettings.push('Record Current Miles');
        }
        if(service_measurement == "Hours"){
          this.AssetCheckSettings.push('Record Current Hours');
        }
      },
      initAssignments() {
        var obj = {
          id: 0,
          driver_id: 0,
          department: "",
          location_id: 0,
          assigned_date: "",
          last_location_id: 0,
          last_known_date: "",
        };

        this.NewAssets.assignments.push(obj);
      },
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch:true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
            if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
              this.NewAssets.branch_id = this.Branches[0].id;
              this.select_branch = false;
            }
          }
        });
      },
      deleteAssignments(assignmentsIndex) {
        this.NewAssets.assignments.splice(assignmentsIndex, 1);
      },
      GetDriverList() {
        Axios.post(Endpoints.Driver.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.DriverList = Response.data.drivers;
          }
        });
      },
      GetCategoryList() {
        Axios.post(Endpoints.Assets.Category.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.CategoryList = Response.data.CategoryList;
          }
        });
      },
      GetGroupList() {
        Axios.post(Endpoints.Assets.Group.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.GroupList = Response.data.GroupList;
          }
        });
      },
      GetLocationList() {
        Axios.post(Endpoints.Assets.Location.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.LocationList = Response.data.LocationList;
          }
        });
      },
      GetOwnershipList() {
        Axios.post(Endpoints.Assets.Ownership.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response?.data?.success) {
            this.OwnershipList = Response.data.OwnershipList;
          }
        });
      },
      SetSubCategories() {
        this.SubCategoryList = [];
        var CategoryID = this.NewAssets.category;
        if (CategoryID > 0) {
          this.CategoryList.forEach((element) => {
            if (
              element.id === CategoryID &&
              element.sub_categories &&
              element.sub_categories.length > 0
            ) {
              this.SubCategoryList = element.sub_categories;
            }
          });
        }
      },

      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      AddAssetsData() {
        this.Saving = true;
        if (this.$refs.file && this.$refs.file.files[0]) {
        let formData = new FormData();
        formData.append("token", localStorage.getItem("token"));
        formData.append("storage_type", "CFAST");
        formData.append("file", this.file);
        Axios.post(Endpoints.File.Upload, formData).then((Response) => {
          this.Saving = false;
          if (Response?.data?.success == true) {
            this.NewAssets.photo = Response.data.file;
            this.UploadAdditionalFile();
          } else {
            this.$swal
              .fire("Error in File Uploading", "", "error")
              .then(() => {});
          }
        });
      }else{
        this.UploadAdditionalFile();
      }
      },
      UploadAdditionalFile() {
        if (this.$refs.additional_files && this.$refs.additional_files.files[0]) {
          const files = this.$refs.additional_files.files;
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            // Validate if file is an image
            if (!file.type.match('image.*')) {
              continue;
            }
            this.AdditionalFilesSaving = true;
            let formData = new FormData();
            formData.append('token', localStorage.getItem('token'));
            formData.append('storage_type', 'CFAST');
            formData.append('file', file);
            Axios.post(Endpoints.File.Upload, formData).then((Response) => {
              if (Response?.data?.success == true) {
                this.AdditionalFilesSaving = false;
                var FileName = Response.data.file
                  this.AdditionalImages.push(FileName);
                  if(files.length == (i+1)){
                    this.NewAssets.additional_photos = this.AdditionalImages;
                    this.AddAssetsSubmit();
                  }
              } else {
                this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
              }
            });
          }
        }else{
          this.AddAssetsSubmit();
        }
        
      },
      AddAssetsSubmit() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;

        this.NewAssets.asset_check_settings = this.AssetCheckSettings;
        Axios.post(Endpoints.Assets.Create, {
          token: localStorage.getItem("token"),
          SubmitAssets: this.NewAssets,
        }).then((Response) => {
          this.Saving = false;
          if (Response?.data?.success == true) {
            this.$swal("Assets Added Successfully", "", "success").then(() => {
              this.$router.push("/assets/list");
            });
          } else {
            this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
          }
        });
      },

      GetNextServiceHours(){
      	if(+this.NewAssets.last_service_hours > 0 && +this.NewAssets.service_interval_hours > 0){
      		this.NewAssets.next_service_hours = +this.NewAssets.last_service_hours + +this.NewAssets.service_interval_hours
      	}
      },
      GetNextServiceMiles(){
      	if(+this.NewAssets.last_service_miles > 0 && +this.NewAssets.service_interval_miles > 0){
      		this.NewAssets.next_service_miles = +this.NewAssets.last_service_miles + +this.NewAssets.service_interval_miles
      	}
      },
      GetNextServiceDate(){      	
      	if(this.NewAssets.last_service_date !="" && +this.NewAssets.service_interval_months > 0){
      		var newDate = moment(this.NewAssets.last_service_date).add(+this.NewAssets.service_interval_months, 'M').format('YYYY-MM-DD');       		      		
      		this.NewAssets.next_service_date = newDate
      	}
      },
      SetVehicleTrackerStatus(type) {
        this.NewAssets.tracker_status = type;
      },
      onSelectTrackerCompany() {
      	if(this.NewAssets.tracker_company != 'Other'){
	      	this.$swal.fire({
	          title: "Fetching data ...",	          
	          text: "Please wait...",	          
	          showConfirmButton: false,
	          allowOutsideClick: false,
	        });
	        var obj = { 
	        	token: localStorage.getItem("token"), 
	        	asset_serial_number: this.NewAssets.serial_number,
	        	tracker_company: this.NewAssets.tracker_company 
	    	};
	        Axios.post(Endpoints.Assets.GetInseegoData, obj).then((Response) => {
	          this.ShowLoader = false;
	          if (Response?.data?.success) {
	          	this.NewAssets.inseego_node_id = Response.data.NodeId;
	            this.$swal.fire(Response?.data?.message || "Something went wrong", "", "success");
	          }else{
	          	this.$swal.close();
	          }
	        });
	    }else{
	    	this.NewAssets.inseego_node_id = null;
	    }     
      },

    },
  };
</script>

<style lang="scss" scoped>
  @import "./assetsadd.scss";
</style>
